import React from "react";
import { useParams, useSearchParams } from "react-router-dom";
import ProtectedRoute from "@/components/ProtectedRoute";
import RoleGate from "@/components/RoleGate";
import { useProjectContext } from "@/hooks/useProjectContext";

export default function WorkplannerStatus() {
    const { projectId } = useParams<{ projectId: string }>();
    const [searchParams] = useSearchParams();
    const companyId = searchParams.get("companyId");
    const { projectName } = useProjectContext();

    return (
        <ProtectedRoute>
            <RoleGate allow={["SUPERADMIN", "ADMIN"]}>
                <div className="grid grid-cols-12 gap-y-10 gap-x-6">
                    <div className="col-span-12">
                        <div className="flex items-center justify-center min-h-[400px]">
                            <div className="text-center">
                                <h2 className="text-2xl font-semibold text-slate-600 dark:text-slate-300">
                                    Coming Soon
                                </h2>
                                <p className="mt-2 text-slate-500 dark:text-slate-400">
                                    Workplanner Status feature is under development
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </RoleGate>
        </ProtectedRoute>
    );
}
